import {
  coordinatesDistance,
  UserGeolocation,
} from '@/utils/helpers/mapLocation';

export default class UnitDataGeolocation {
  static _createListWithDistanceProperty(unitsData, userPosition) {
    const listWithDistanceProperty = unitsData.map((item) => {
      const itemPosition = item.endereco?.posicao;

      let itemDistance = itemPosition?.latitude
        ? (coordinatesDistance(userPosition, itemPosition)).toFixed(1)
        : null;

      if (itemDistance > 150) {
        itemDistance = 150;
      }

      const newItem = {
        ...item,
        distancia: itemDistance
      };

      return newItem;
    });

    return listWithDistanceProperty;
  }

  static async isGeolocationEnabled() {
    const permissionStatus = await UserGeolocation.isGeolocationEnabled();

    return permissionStatus?.state === 'granted';
  }

  static async getUnitsListWithDistanceProperty(data) {
    const unitsData = Array.isArray(data) ? data : [data];

    const userPosition = await UserGeolocation.getUserGeolocation();

    if (userPosition?.position && userPosition.position.latitude) {
      const listWithDistanceProperty =
        UnitDataGeolocation._createListWithDistanceProperty(unitsData, userPosition.position);

      return listWithDistanceProperty;
    }

    return userPosition;
  }
}
